import { OpenableOverlay, OpenableOverlayProps, withBreakpointRange, withToggleableOverlay } from '@optimus-web/core';
import { WithBreakpointRange, isMobile, unreliableIsMobileDevice } from '@mews-commander/ui';
import UserMenuAvatar from './UserMenuAvatar';
import UserMenuContent from './UserMenuContent';

const UserMenu = ({ breakpointRange }: WithBreakpointRange) =>
    isMobile(breakpointRange) || unreliableIsMobileDevice() ? (
        // @ts-expect-error $TSFixMeError: JSX element type 'MobileUserMenuOverlay' does not have any construct or call signatures.
        <MobileUserMenuOverlay />
    ) : (
        // @ts-expect-error $TSFixMeError: JSX element type 'DesktopUserMenuOverlay' does not have any construct or call signatures.
        <DesktopUserMenuOverlay />
    );

const USER_MENU_OVERLAY_MAX_HEIGHT = 515;
const UserMenuOpenableOverlay = (props: OpenableOverlayProps) => (
    <OpenableOverlay maxHeight={USER_MENU_OVERLAY_MAX_HEIGHT} {...props} />
);

const withToggleableOverlayFactory = ({ scrollAway = true } = {}) =>
    withToggleableOverlay({
        scrollAway,
        clickAway: true,
    })({
        HandleComponent: UserMenuAvatar,
        ContentComponent: UserMenuContent,
        OpenableOverlayComponent: UserMenuOpenableOverlay,
    });

const DesktopUserMenuOverlay = withToggleableOverlayFactory({ scrollAway: true });
const MobileUserMenuOverlay = withToggleableOverlayFactory({ scrollAway: false });

export default withBreakpointRange(UserMenu);
